import React, { useEffect, useState } from "react";

import { Modal } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import BadgeIcon from "@mui/icons-material/Badge";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";

import request from "../../../Helpers/API";

const FORM_VACIO = { idasesor: "", idlinea: "" };

export const CRM_ModalAsesor = ({ open, onClose, idcliente, onGuardado, opcionesAsesores = [], opcionesLineas = [] }) => {
  const [form, setForm] = useState(FORM_VACIO);
  const [busquedaAsesor, setBusquedaAsesor] = useState("");
  const [mostrarAsesores, setMostrarAsesores] = useState(false);

  useEffect(() => {
    if (open) {
      setForm(FORM_VACIO);
      setBusquedaAsesor("");
    }
  }, [open]);

  const asesorSeleccionado = opcionesAsesores.find((a) => String(a.id) === String(form.idasesor)) || null;

  const resultadosAsesor = mostrarAsesores
    ? opcionesAsesores.filter((a) => (a.empleado || "").toLowerCase().includes(busquedaAsesor.toLowerCase()))
    : [];

  const handleSeleccionarAsesor = (a) => {
    setForm((prev) => ({ ...prev, idasesor: a.id }));
    setBusquedaAsesor("");
    setMostrarAsesores(false);
  };

  const handleQuitarAsesor = () => setForm((prev) => ({ ...prev, idasesor: "" }));

  const handleChangeLinea = (e) => {
    setForm((prev) => ({ ...prev, idlinea: e.target.value }));
  };

  const validar = () => {
    if (!form.idasesor) { Swal.fire("EQUIPO", "El asesor es requerido", "warning"); return false; }
    if (!form.idlinea) { Swal.fire("EQUIPO", "La línea es requerida", "warning"); return false; }
    return true;
  };

  const handleGuardar = () => {
    if (!validar()) return;

    const body = {
      IdCliente: Number(idcliente),
      IdVendedor: Number(form.idasesor),
      IdLinea: Number(form.idlinea),
    };

    request
      .post("Clientes/GuardarAsesorCliente", body)
      .then(async (result) => {
        await Swal.fire("EQUIPO", "Asesor asignado con éxito", "success");
        onGuardado(result);
        onClose();
      })
      .catch((error) => Swal.fire("EQUIPO", JSON.stringify(error), "error"));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="crm-modal-card crm-modal-card-overflow-visible">
        <button type="button" className="crm-modal-cerrar" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </button>

        <h3 className="crm-modal-titulo">Asignar asesor</h3>

        <div className="crm-modal-body">
          <div className="crm-field">
            <label>Asesor</label>
            {asesorSeleccionado ? (
              <div className="crm-detalle-cliente-asociado">
                <div>
                  <span className="asociado-nombre">{asesorSeleccionado.empleado}</span>
                  <span className="asociado-id mono">{asesorSeleccionado.id}</span>
                </div>
                <button type="button" className="btn-quitar-asociado" onClick={handleQuitarAsesor}>×</button>
              </div>
            ) : (
              <div className="crm-home-search-section">
                <div className={`crm-home-search-bar${resultadosAsesor.length > 0 ? " search-open" : ""}`}>
                  <SearchIcon className="crm-search-icon" />
                  <input
                    type="text"
                    className="crm-search-input"
                    placeholder="Buscar asesor por nombre..."
                    value={busquedaAsesor}
                    onChange={(e) => setBusquedaAsesor(e.target.value)}
                    onFocus={() => setMostrarAsesores(true)}
                    onBlur={() => setTimeout(() => setMostrarAsesores(false), 150)}
                    autoComplete="off"
                  />
                </div>

                {resultadosAsesor.length > 0 && (
                  <div className="crm-search-dropdown">
                    {resultadosAsesor.map((a) => (
                      <div
                        key={a.id}
                        className="crm-search-result"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => handleSeleccionarAsesor(a)}
                      >
                        <div className="crm-res-avatar"><AccountCircleOutlinedIcon /></div>
                        <div className="crm-res-info">
                          <span className="crm-res-nombre">{a.empleado}</span>
                          <span className="crm-res-meta">
                            <BadgeIcon /> {a.id}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="crm-field">
            <label>Línea</label>
            <select className="crm-field-editable" value={form.idlinea} onChange={handleChangeLinea}>
              <option value="">Seleccionar</option>
              {opcionesLineas.map((l) => <option key={l.idlinea} value={l.idlinea}>{l.linea}</option>)}
            </select>
          </div>
        </div>

        <div className="crm-modal-buttons">
          <button type="button" className="btn-secundario-outline" onClick={onClose}>Cancelar</button>
          <button type="button" className="btn-primario-solido" onClick={handleGuardar}>Guardar</button>
        </div>
      </div>
    </Modal>
  );
};
